import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { AccordionComponent, AccordionPanelComponent, ModalService, SwitcherComponent } from 'mbs-ui-kit';
import { EnableReserveAuthAgreementModalComponent } from 'mbs-ui-shared@components/enable-reserve-auth-agreement-modal/enable-reserve-auth-agreement-modal.component';
import { ReserveAuthAddComponent } from 'mbs-ui-shared@components/reserve-auth-add/reserve-auth-add.component';
import { ConfigurationService } from 'mbs-ui-shared@services/configuration.service';
import { noop } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'mbs-reserve-auth-panel',
  templateUrl: './reserve-auth-panel.html',
  styleUrls: ['./reserve-auth-panel.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    I18NextPipe,
    SwitcherComponent,
    ReserveAuthAddComponent,
    AccordionComponent,
    AccordionPanelComponent
  ]
})
export class ReserveAuthPanelComponent implements OnInit {
  private config = inject(ConfigurationService);
  private modalService = inject(ModalService);

  protected readonly isReserveAuthEnabled = !!this.config.get('featureFlags')?.ReserveAuthMethod;
  public isReserveAuthOpenedControl = new FormControl(false);

  @Input() authId: string;
  @Output() enabling = new EventEmitter();
  @Output() confirmed = new EventEmitter();

  ngOnInit(): void {
    this.isReserveAuthOpenedControl.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
      if (value) {
        setTimeout(() => {
          this.isReserveAuthOpenedControl.patchValue(false, { emitEvent: false });
          this.enabling.emit(false);
          this.isReserveAuthOpenedControl.updateValueAndValidity();
        }, 0);
        this.modalService
          .openCustom(EnableReserveAuthAgreementModalComponent)
          .then(() => {
            this.isReserveAuthOpenedControl.patchValue(true, { emitEvent: false });
            this.enabling.emit(true);
          })
          .catch(noop);
      } else {
        this.enabling.emit(false);
      }
    });
  }
}
